import { render, staticRenderFns } from "./DocumentTypesPanel.vue?vue&type=template&id=7f4b12a0&scoped=true&"
import script from "./DocumentTypesPanel.vue?vue&type=script&lang=js&"
export * from "./DocumentTypesPanel.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypesPanel.vue?vue&type=style&index=0&id=7f4b12a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b12a0",
  null
  
)

export default component.exports